import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FieldTypeConfig } from '@ngx-formly/core/lib/templates/field.type';

@Component({
  selector: 'planning-trip',
  templateUrl: './planning-trip.component.html',
  styleUrls: ['./planning-trip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PlanningTripComponent extends FieldType<FieldTypeConfig> {
  @Output() hideModal = new EventEmitter<void>();
}
